/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Redo_Restore_EventInputs */



/**
* | output |
* | --- |
* | "Restore undone" |
*
* @param {Assistant_Redo_Restore_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_redo_restore_event = /** @type {((inputs?: Assistant_Redo_Restore_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Redo_Restore_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rétablir l'état initial")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückgängig gemachte Aktionen wiederherstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina annullato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить отмененные действия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurar deshecho")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复未完成的操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("元に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधूरे कार्यों को पुनर्स्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar desfeito")
	return /** @type {LocalizedString} */ ("Restore undone")
});